module.exports = __webpack_public_path__ + "static/media/zoo_3.425bd251.jpg";